module.exports = __webpack_public_path__ + "img/13ne.4c2a3c49.svg";